import { render, staticRenderFns } from "./ListaOrigenes.vue?vue&type=template&id=8110a760&"
import script from "./ListaOrigenes.vue?vue&type=script&lang=js&"
export * from "./ListaOrigenes.vue?vue&type=script&lang=js&"
import style0 from "./ListaOrigenes.vue?vue&type=style&index=0&id=8110a760&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports